export const DataTestId = {
  RELEASE_PAGE_CONNECT_BUTTON: 'RELEASE_PAGE_CONNECT_BUTTON',
  RELEASE_PAGE_COLLECT_BUTTON: 'RELEASE_PAGE_COLLECT_BUTTON',
  RELEASE_PAGE_COLLECT_SECONDARY_BUTTON: 'RELEASE_PAGE_COLLECT_SECONDARY_BUTTON',
  RELEASE_PAGE_SELL_BUTTON: 'RELEASE_PAGE_SELL_BUTTON',
  RELEASE_PAGE_OPENSEA_BUTTON: 'RELEASE_PAGE_OPENSEA_BUTTON',
  VERIFY_ACCOUNT_MODAL_BUTTON: 'VERIFY_ACCOUNT_MODAL_BUTTON',
  VERIFY_ACCOUNT_MODAL_DISCONNECT_BUTTON: 'VERIFY_ACCOUNT_MODAL_DISCONNECT_BUTTON',
  ARTIST_PAGE_SOUNDS_RELEASED: 'ARTIST_PAGE_SOUNDS_RELEASED',
  COLLECTORS_CARD: 'COLLECTORS_CARD',
  JOIN_DROP_BUTTON: 'JOIN_DROP_BUTTON',
  HERO_FEATUED_RELEASE_CONTAINER: 'HERO_FEATUED_RELEASE_CONTAINER',
  HERO_FEATURED_RELEASE_CONTAINER_ARTIST_LINK: 'HERO_FEATURED_RELEASE_CONTAINER_ARTIST_LINK',
  RELEASE_CARD: 'RELEASE_CARD',
  ARTIST_PAGE_COLLECTORS_COUNT: 'ARTIST_PAGE_COLLECTORS_COUNT',
  USER_MENU_ITEMS_CONTAINER: 'USER_MENU_ITEMS_CONTAINER',
  USER_MENU_CONTAINER: 'USER_MENU_CONTAINER',
  COLLECTED_BY_MODAL_ROW: 'COLLECTED_BY_MODAL_ROW',
  ALL_SOUNDS_DROPDOWN: 'ALL_SOUNDS_DROPDOWN',
  BUY_AND_COMMENT_MODAL_CONTAINER: 'BUY_AND_COMMENT_MODAL_CONTAINER',
  BUY_MODAL_COLLECT_BUTTON: 'BUY_MODAL_COLLECT_BUTTON',
  MINT_INFO_COLLECTED: 'MINT_INFO_COLLECTED',
  MINT_INFO_OPEN_EDITION_DURATION: 'MINT_INFO_OPEN_EDITION_DURATION',
  MINT_INFO_COLLECTED_MAX: 'MINT_INFO_COLLECTED_MAX',
  MINT_INFO_OPEN_EDITION_CONTENT: 'MINT_INFO_OPEN_EDITION_CONTENT',
  MINT_INFO_RANGE_EDITION: 'MINT_INFO_RANGE_EDITION',
  RELEASE_PAGE_COMMENT_BUTTON: 'RELEASE_PAGE_COMMENT_BUTTON',
  SET_TIMESLOT_MODAL_WAVEFORM: 'SET_TIMESLOT_MODAL_WAVEFORM',
  SET_TIMESLOT_MODAL_SKIP_BUTTON: 'SET_TIMESLOT_MODAL_SKIP_BUTTON',
  SET_TIMESLOT_MODAL_NEXT_BUTTON: 'SET_TIMESLOT_MODAL_NEXT_BUTTON',
  SET_COMMENT_MODAL_TESTAREA: 'SET_COMMENT_MODAL_TESTAREA',
  SET_COMMENT_MODAL_NEXT_BUTTON: 'SET_COMMENT_MODAL_NEXT_BUTTON',
  ALLOW_LIST_CSV_INPUT: 'ALLOW_LIST_CSV_INPUT',
  INVALID_ADDRESSES_TOAST_MESSAGE: 'INVALID_ADDRESSES_TOAST_MESSAGE',
  DUPLICATE_ADDRESSES_TOAST_MESSAGE: 'DUPLICATE_ADDRESSES_TOAST_MESSAGE',
  AVAILABLE_TO_WITHDRAW: 'AVAILABLE_TO_WITHDRAW',
  YOUR_EARNINGS: 'YOUR_EARNINGS',
  CONFIRM_WITHDRAWAL_MODAL_WITHDRAW_BUTTON: 'CONFIRM_WITHDRAWAL_MODAL_WITHDRAW_BUTTON',
  CONFIRM_WITHDRAWAL_MODAL_LIST: 'CONFIRM_WITHDRAWAL_MODAL_LIST',
  CONFIRM_WITHDRAWAL_MODAL_TOTAL: 'CONFIRM_WITHDRAWAL_MODAL_TOTAL',
  EARNINGS_DESKTOP_TABLE_RELEASE_ROW: 'EARNINGS_DESKTOP_TABLE_RELEASE_ROW',
  EARNINGS_MOBILE_TABLE_RELEASE_ROW: 'EARNINGS_MOBILE_TABLE_RELEASE_ROW',
  EARNINGS_ROW_RELEASE_TITLE: 'EARNINGS_ROW_RELEASE_TITLE',
  UPLOAD_STEP_NAV_BAR: (step: number) => `UPLOAD_STEP_NAV_BAR_${step}` as const,
  UPLOAD_FREE_MINT_ALLOWLIST_MODAL_LABEL: 'UPLOAD_FREE_MINT_ALLOWLIST_MODAL_LABEL',
  UPLOAD_TOOL_PRESALE_ALLOWLIST_MODAL_LABEL: 'UPLOAD_TOOL_PRESALE_ALLOWLIST_MODAL_LABEL',
  UPLOAD_ALLOWLIST_MODAL_COLLECTORS_TOTAL: 'UPLOAD_ALLOWLIST_MODAL_COLLECTORS_TOTAL',
  UPLOAD_ALLOWLIST_MODAL_MANUAL_TOTAL: 'UPLOAD_ALLOWLIST_MODAL_MANUAL_TOTAL',
  FEED_DIVIDER: 'FEED_DIVIDER',
  FEED_DIVIDER_DATE: 'FEED_DIVIDER_DATE',
  FEED_NEW_ACTIVITY_BUTTON: 'FEED_NEW_ACTIVITY_BUTTON',
  POPUP_BUTTON_WRAPPER: 'POPUP_BUTTON_WRAPPER',
  ACCESS_BADGE: 'ACCESS_BADGE',
  MODAL_CLOSE_BUTTON: 'MODAL_CLOSE_BUTTON',
  DATE_PICKER: 'DATE_PICKER',
  SONG_PAGE_RANGE_PROGRESS_BAR: 'SONG_PAGE_RANGE_PROGRESS_BAR',
  SONG_PAGE_OPEN_EDITION_ENDS_IN_TIMER: 'SONG_PAGE_OPEN_EDITION_ENDS_IN_TIMER',
  SONG_PAGE_STATIC_PROGRESS_BAR: 'SONG_PAGE_STATIC_PROGRESS_BAR',
  SONG_PAGE_PRICE: 'SONG_PAGE_PRICE',
  SONG_PAGE_MINTING_DROPDOWN: 'SONG_PAGE_MINTING_DROPDOWN',
  SONG_PAGE_MINTING_DROPDOWN_COMMENT_BUTTON: 'SONG_PAGE_MINTING_DROPDOWN_COMMENT_BUTTON',
  DATE_PICKER_FREE_MINT_START_TIME: 'DATE_PICKER_FREE_MINT_START_TIME',
  DATE_PICKER_PRESALE_START_TIME: 'DATE_PICKER_PRESALE_START_TIME',
  DATE_PICKER_PUBLIC_MINT_START_TIME: 'DATE_PICKER_PUBLIC_MINT_START_TIME',
  TOGGLE_SWITCH: 'TOGGLE_SWITCH',
  TOGGLE_SWITCH_FREE_MINT: 'TOGGLE_SWITCH_FREE_MINT',
  TOGGLE_SWITCH_PRESALE: 'TOGGLE_SWITCH_PRESALE',
  TOGGLE_SWITCH_GA_EDITION: 'TOGGLE_SWITCH_GA_EDITION',
  TOGGLE_SWITCH_SPOTIFY_PRESAVE: 'TOGGLE_SWITCH_SPOTIFY_PRESAVE',
  UPLOAD_TOOL_AUCTION_CONFIG_FREE_MINT_START_TIME_ERROR:
    'UPLOAD_TOOL_AUCTION_CONFIG_FREE_MINT_START_TIME_ERROR',
  UPLOAD_TOOL_AUCTION_CONFIG_PRESALE_START_TIME_ERROR:
    'UPLOAD_TOOL_AUCTION_CONFIG_PRESALE_START_TIME_ERROR',
  UPLOAD_TOOL_SAVE_AND_CONTINUE_BUTTON: 'UPLOAD_TOOL_SAVE_AND_CONTINUE_BUTTON',
  UPLOAD_TOOL_AUCTION_GRID: 'UPLOAD_TOOL_AUCTION_GRID',
  DATE_PICKER_PUBLIC_START_TIME: 'DATE_PICKER_PUBLIC_START_TIME',
  UPLOAD_TOOL_TOTAL_MINT_RANGE_MIN: 'UPLOAD_TOOL_TOTAL_MINT_RANGE_MIN',
  UPLOAD_TOOL_TOTAL_MINT_RANGE_MAX: 'UPLOAD_TOOL_TOTAL_MINT_RANGE_MAX',
  UPLOAD_TOOL_AUCTION_STEP_PRESALE_PRICE: 'UPLOAD_TOOL_AUCTION_STEP_PRESALE_PRICE',
  UPLOAD_TOOL_AUCTION_STEP_PUBLIC_PRICE: 'UPLOAD_TOOL_AUCTION_STEP_PUBLIC_PRICE',
  UPLOAD_TOOL_AUCTION_STEP_FREE_MINT_MAX_SUPPLY: 'UPLOAD_TOOL_AUCTION_STEP_FREE_MINT_MAX_SUPPLY',
  UPLOAD_TOOL_AUCTION_STEP_PRESALE_MAX_SUPPLY: 'UPLOAD_TOOL_AUCTION_STEP_PRESALE_MAX_SUPPLY',
  UPLOAD_TOOL_AUCTION_STEP_PUBLIC_MAX_SUPPLY: 'UPLOAD_TOOL_AUCTION_STEP_PUBLIC_MAX_SUPPLY',
  UPLOAD_TOOL_REVIEW_AUCTION_SECTION: 'UPLOAD_TOOL_REVIEW_AUCTION_SECTION',
  UPLOAD_TOOL_REVIEW_STEP_PRESALE_PRICE: 'UPLOAD_TOOL_REVIEW_STEP_PRESALE_PRICE',
  UPLOAD_TOOL_REVIEW_STEP_PUBLIC_PRICE: 'UPLOAD_TOOL_REVIEW_STEP_PUBLIC_PRICE',
  UPLOAD_TOOL_REVIEW_STEP_FREE_MINT_MAX_SUPPLY: 'UPLOAD_TOOL_REVIEW_STEP_FREE_MINT_MAX_SUPPLY',
  UPLOAD_TOOL_REVIEW_STEP_PRESALE_MAX_SUPPLY: 'UPLOAD_TOOL_REVIEW_STEP_PRESALE_MAX_SUPPLY',
  UPLOAD_TOOL_REVIEW_STEP_OPEN_FREE_MINT_ALLOWLIST_MODAL:
    'UPLOAD_TOOL_REVIEW_STEP_OPEN_FREE_MINT_ALLOWLIST_MODAL',
  UPLOAD_TOOL_REVIEW_STEP_OPEN_PRESALE_ALLOWLIST_MODAL:
    'UPLOAD_TOOL_REVIEW_STEP_OPEN_PRESALE_ALLOWLIST_MODAL',
  UPLOAD_TOOL_AUCTION_STEP_FIXED_EDITION: 'UPLOAD_TOOL_AUCTION_STEP_FIXED_EDITION',
  UPLOAD_CONFIRM_VALUES_CHECKBOX: 'UPLOAD_CONFIRM_VALUES_CHECKBOX',
  UPLOAD_TOOL_CONTINUE_EDITING_BUTTON: 'UPLOAD_TOOL_CONTINUE_EDITING_BUTTON',
  UPLOAD_TOOL_DRAFT_RELEASE_ROW: 'UPLOAD_TOOL_DRAFT_RELEASE_ROW',
  SPLITS_FORM_RECIPIENT_ROW: 'SPLITS_FORM_RECIPIENT_ROW',
  SPLITS_FORM_PERCENT_INPUT: 'SPLITS_FORM_PERCENT_INPUT',
  VIEW_SONG_OR_ALBUM_BUTTON: 'VIEW_SONG_OR_ALBUM_BUTTON',
  WITHDRAW_BUTTON: 'WITHDRAW_BUTTON',
  WITHDRAW_ALL_BUTTON: 'WITHDRAW_ALL_BUTTON',
  SEE_ALL_LINK: (path: string) => `SEE_ALL_LINK_${path.toUpperCase()}`,
  BUY_EDITION_MODAL_COLLECTED_RATIO: 'BUY_EDITION_MODAL_COLLECTED_RATIO',
  BUY_EDITION_MODAL_PRICE: 'BUY_EDITION_MODAL_PRICE',
  BUY_EDITION_MODAL_MAX_MINTABLE_PER_ACCOUNT: 'BUY_EDITION_MODAL_MAX_MINTABLE_PER_ACCOUNT',
  ADD_TO_SHELF_MENU_ITEM_DROPDOWN: 'ADD_TO_SHELF_MENU_ITEM_DROPDOWN',
  FEED_POST_MENU_ITEM_DROPDOWN: 'FEED_POST_MENU_ITEM_DROPDOWN',
  ADD_TO_QUEUE_MENU_ITEM_DROPDOWN: 'ADD_TO_QUEUE_MENU_ITEM_DROPDOWN',
  ADD_AS_FEATURE_MENU_ITEM_DROPDOWN: 'ADD_AS_FEATURE_MENU_ITEM_DROPDOWN',
  LIKE_SOUND_MENU_ITEM_DROPDOWN: 'LIKE_SOUND_MENU_ITEM_DROPDOWN',
  ALLOWLIST_MULTISELECT: (type: 'ARTISTS' | 'RELEASES') => `ALLOWLIST_MULTISELECT_${type}`,
  ALLOWLIST_MULTISELECT_SELECTED: (nameOrTitle: string) =>
    `ALLOWLIST_MULTISELECT_SELECTED_${nameOrTitle}`,
  ALLOWLIST_MULTISELECT_ROW: (nameOrTitle: string) => `ALLOWLIST_MULTISELECT_ROW_${nameOrTitle}`,
  ALLOWLIST_MULTISELECT_SELECTED_ITEMS_CONTAINER: 'ALLOWLIST_MULTISELECT_SELECTED_ITEMS_CONTAINER',
  BONDING_CURVE_MINT_COMPONENT: 'BONDING_CURVE_MINT_COMPONENT',
  BONDING_CURVE_MINT_COMPONENT_COLLECT: 'BONDING_CURVE_MINT_COMPONENT_COLLECT',
  BONDING_CURVE_MINT_COMPONENT_SELL: 'BONDING_CURVE_MINT_COMPONENT_SELL',
  BONDING_CURVE_OWNER_SELLING_UNAVAILABLE: 'BONDING_CURVE_OWNER_SELLING_UNAVAILABLE',
  BONDING_CURVE_SELLING_UNAVAILABLE: 'BONDING_CURVE_SELLING_UNAVAILABLE',
  BONDING_CURVE_COLLECTING_UNAVAILABLE: 'BONDING_CURVE_COLLECTING_UNAVAILABLE',
  BONDING_CURVE_QUANTITY_ROW: 'BONDING_CURVE_QUANTITY_ROW',
  BONDING_CURVE_TOTAL: 'BONDING_CURVE_TOTAL',
  UNABLE_TO_SELL_GOLDEN_EGG: 'UNABLE_TO_SELL_GOLDEN_EGG',
  NO_EDITIONS_TO_SELL: 'NO_EDITIONS_TO_SELL',
  USER_DOES_NOT_HAVE_ENOUGH_EDITIONS: 'USER_DOES_NOT_HAVE_ENOUGH_EDITIONS',
  AMOUNT_TO_SELL_CONTENT: 'AMOUNT_TO_SELL_CONTENT',
  REDUCE_QUANTITY_ERROR_BUTTON: 'REDUCE_QUANTITY_ERROR_BUTTON',
  BONDING_CURVE_MAX_THRESHOLD_REACHED: 'BONDING_CURVE_MAX_THRESHOLD_REACHED',
  OPTIMISM_NETWORK: 'OPTIMISM_NETWORK',
  ETHEREUM_NETWORK: 'ETHEREUM_NETWORK',
  GET_NOTIFIED_BUTTON: 'GET_NOTIFIED_BUTTON',
  RELEASE_PAGE_MARKETPLACE_BUTTON: 'RELEASE_PAGE_MARKETPLACE_BUTTON',
  TIMER_BADGE: 'TIMER_BADGE',
  SOLD_OUT_BADGE: 'SOLD_OUT_BADGE',
  ENDED_BADGE: 'ENDED_BADGE',
  QUANTITY_BADGE: 'QUANTITY_BADGE',
  SECONDARY_BADGE: 'SECONDARY_BADGE',
  SPOTIFY_PRESAVE_BUTTON: 'SPOTIFY_PRESAVE_BUTTON',
  CHANNEL_SETTINGS_SAVE_BUTTON: 'CHANNEL_SETTINGS_SAVE_BUTTON',
} as const;

export const MOCK_TEST_S3 = 'test';
